module.exports = __webpack_public_path__ + "static/enterprise_solutions-7a839b7ad49a8df71f2497ee66fb5157.svg";